import StandardsUnitRow from './StandardsUnitRow';
import { CoreStandard } from '../../core/context/contextHelpers';
import styles from './StandardsByUnit.module.scss';

interface Props {
  colA: string;
  colB: string;
  colC: string;
  colD: string;
  data: {
    id: string;
    displayName: string;
    completeStandards: string[];
    incompleteStandards: string[];
  }[];
  barColor: string;
  isShouldAnimate: boolean;
  standardsLibrary: { [key: string]: CoreStandard };
}

const StandardsByUnit = ({
  colA,
  colB,
  colC,
  colD,
  data,
  barColor,
  isShouldAnimate,
  standardsLibrary,
}: Props): JSX.Element => {
  return (
    <div className={styles.container}>
      <div className={styles.columnTitles}>
        <div className={styles.col1}>
          <h4>{colA}</h4>
        </div>
        <div className={styles.col2}>
          <h4>{colB}</h4>
        </div>
        <div className={styles.col3}>
          <h4>{colC}</h4>
        </div>
        <div className={styles.col4}>
          <h4>{colD}</h4>
        </div>
      </div>
      {data.map((unit) => {
        const { displayName, id, incompleteStandards, completeStandards } = unit;
        return (
          <StandardsUnitRow
            key={`${id} unit completion`}
            title={displayName}
            incompleteStandards={incompleteStandards}
            completeStandards={completeStandards}
            barColor={barColor}
            isShouldAnimate={isShouldAnimate}
            standardsLibrary={standardsLibrary}
            id={id}
          />
        );
      })}
    </div>
  );
};

export default StandardsByUnit;
